import './styles.modules.scss';
import React, { useCallback, useState } from 'react';

type OrderTableProps = {
  sizes: string[];
};

const OrderTable: React.FC<OrderTableProps> = ({ sizes, children }) => {
  const [scrollLeft, setScrollLeft] = useState(false);
  const handleScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
    const element = event.currentTarget;
    setScrollLeft(!!element.scrollLeft);
  }, []);

  return (
    <div styleName="order-table">
      <div styleName={`sizes${scrollLeft ? ' shadow' : ''}`}>
        <div styleName="col">
          <div styleName="cell">サイズ</div>
          {sizes.map((size) => (
            <div styleName="cell" key={size}>
              {size}
            </div>
          ))}
          <div styleName="cell" key={'total'}>
            合計
          </div>
        </div>
      </div>
      <div styleName={'order-table-input'} onScroll={handleScroll}>
        {children}
      </div>
    </div>
  );
};

export default OrderTable;
